<template>
    <svg
        class="ql-bookmark-type-icon"
        :class="`ql-bookmark-type-icon--${resolvedType}`"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="2.5 1.5 13 15.5"
        fill="none"
        :aria-label="ariaLabel"
    >
        <title v-if="ariaLabel">{{ ariaLabel }}</title>

        <!-- Shared bookmark ribbon — outline only (never filled) -->
        <path
            class="ql-bookmark-type-icon__ribbon"
            d="M14.2 16.5L9 12.85 3.8 16.5V4.2A1.6 1.6 0 0 1 5.4 2.6h7.2A1.6 1.6 0 0 1 14.2 4.2v12.3z"
            fill="none"
            stroke="currentColor"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
        />

        <text
            v-if="resolvedType === 'act'"
            class="ql-bookmark-type-icon__glyph"
            x="9"
            y="8.9"
            text-anchor="middle"
            dominant-baseline="middle"
            font-family="'Syncopate', sans-serif"
            font-size="4.3"
            font-weight="400"
            font-style="normal"
            fill="currentColor"
        >A</text>

        <text
            v-else-if="resolvedType === 'scene'"
            class="ql-bookmark-type-icon__glyph"
            x="9"
            y="8.9"
            text-anchor="middle"
            dominant-baseline="middle"
            font-family="'Syncopate', sans-serif"
            font-size="4.3"
            font-weight="400"
            font-style="normal"
            fill="currentColor"
        >S</text>

        <path
            v-else
            class="ql-bookmark-type-icon__glyph"
            fill="currentColor"
            transform="translate(9 8.6) scale(0.68) translate(-9 -8.6)"
            d="M9.4 5.15v4.9c-.36-.2-.78-.3-1.2-.3-1.2 0-2.15.82-2.15 1.8s.95 1.8 2.15 1.8 2.15-.82 2.15-1.8V7.25h2V5.15H9.4z"
        />
    </svg>
</template>

<script>
import { markerTypeFromToolIndex } from '@/lib/marker-labels';

export default {
    name: 'BookmarkTypeIcon',
    props: {
        type: {
            type: String,
            default: ''
        },
        markerIndex: {
            type: Number,
            default: null
        }
    },
    computed: {
        resolvedType() {
            if (this.type === 'act' || this.type === 'scene' || this.type === 'song') {
                return this.type;
            }
            if (this.markerIndex !== null && this.markerIndex !== undefined) {
                return markerTypeFromToolIndex(this.markerIndex);
            }
            return 'scene';
        },
        ariaLabel() {
            if (this.resolvedType === 'act') return 'Act structure';
            if (this.resolvedType === 'song') return 'Song structure';
            return 'Scene structure';
        }
    }
};
</script>

<style lang="scss">
.ql-bookmark-type-icon {
    display: block;
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    color: #000;
    overflow: visible;

    /* Root must stay unfilled so dark-mode `svg path { fill }` cannot solid-fill the ribbon */
    fill: none !important;

    &__ribbon {
        fill: none !important;
        stroke: currentColor !important;
        stroke-width: 1;
    }

    &__glyph {
        fill: currentColor !important;
        stroke: none !important;
    }
}

/* Dark mode: inherit white from toolbar/menu `color`, keep ribbon hollow */
.md-theme-show-mode {
    .ql-bookmark-type-icon {
        color: #fff;

        &__ribbon {
            fill: none !important;
            stroke: currentColor !important;
        }

        &__glyph {
            fill: currentColor !important;
            stroke: none !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// bookmark-type-icon.vue?5bd71072